import * as React from "react";

class FlagCheckbox extends React.Component<any, any> {
  render() {
    const { label, inputName, isChecked } = this.props;

    return (
      <div className="form-control--checkbox">
        <input
          readOnly
          className="form-group__checkbox"
          id={inputName}
          type="checkbox"
          name={inputName}
          checked={isChecked}
          onClick={this.props.onClick}
        />
        <label htmlFor={inputName}>{label}</label>
      </div>
    );
  }
}

export default FlagCheckbox;
